const updateUserBrief = (state, data) => {
  state.userBrief = {
    ...state.userBrief,
    ...data
  };
};
const updateToken = (state, token) => {
  state.token = token;
  if (token == '') {
    localStorage.removeItem('token');
  } else {
    localStorage.setItem('token', token);
  }
};
const updatePcToken = (state, pcToken) => {
  state.pcToken = pcToken;
  if (pcToken == '') {
    localStorage.removeItem('pcToken');
  } else {
    localStorage.setItem('pcToken', pcToken);
  }
};
const updateProviderId = (state, providerId) => {
  state.userBrief.providerId = providerId;
  if (providerId == '') {
    localStorage.removeItem('providerId');
  } else {
    localStorage.setItem('providerId', providerId);
  }
};
const updateEncryptionId = (state, encryptionId) => { // 供应商加密ID
  state.userBrief.encryptionId = encryptionId;
};
const updateUserPhone = (state, userPhone) => {
  state.userBrief.phone = userPhone;
};
const updateUserCompanyName = (state, companyName) => {
  state.userBrief.companyName = companyName;
};
const updateTempToken = (state, tempToken) => {
  state.tempToken = tempToken;
};
const updateSealName = (state, sealName) => {
  state.userBrief.sealName = sealName;
};
const updateResigterStep = (state, registerStep) => {
  state.registerStep = registerStep;
};
const updateCompanyId = (state, companyId) => {
  state.userBrief.registerCompanyId = companyId;
};
const updateCompleteStatus = (state, completeStatus) => {
  state.userBrief.needInitialSet = completeStatus;
};
const updateNonUser = (state, {
  phone,
  token,
  password,
  regType
}) => {
  state.nonUser.phone = phone;
  state.nonUser.token = token;
  state.nonUser.password = password;
  state.nonUser.regType = regType;
};

const updateSupplierShowSetPayStatus = (state, status) => { // 更新 是否显示过提示供应商设置支付密码状态
  state.supplierShowSetPayStatus = status;
};

const updateCompanyStatus = (state, status) => { // 更新 是否显示过提示供应商设置支付密码状态
  state.userBrief.companyStatus = status;
};

export default {
  updateUserBrief,
  updateToken,
  updatePcToken,
  updateProviderId,
  updateUserPhone,
  updateUserCompanyName,
  updateTempToken,
  updateSealName,
  updateResigterStep,
  updateCompanyId,
  updateCompleteStatus,
  updateNonUser,
  updateSupplierShowSetPayStatus,
  updateEncryptionId,
  updateCompanyStatus
};
